import moment from 'moment'

export function calculateAge(dateOfBirth: string): number {
  const birthDate = moment(dateOfBirth, 'YYYY-MM-DD')
  const currentDate = moment()
  return currentDate.diff(birthDate, 'years')
}
